
















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PreviewDetail',  
  props: {    
    aspx:{
      type:String,
      default:"page_view"
    },
    id:{
      type:Number,
      default:""
    }
  }
})
export default class PreviewDetail extends Vue {
  aspx!:string
  id!:number
  
  get configuration(){
    return this.$store.myGetters.configuration
  }
}
